"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34],{

/***/ 3302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ column_Column; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/gridview/column/Column.tsx


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Column = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, offset = _param.offset, order = _param.order, size = _param.size, children = _param.children, testId = _param.testId, rest = _objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "offset",
        "order",
        "size",
        "children",
        "testId"
    ]);
    var classNames = [
        'col'
    ];
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value !== undefined) {
                if (prop === 'size') {
                    classNames.push("col".concat(breakpoint, "-").concat(value));
                } else {
                    classNames.push("col".concat(breakpoint, "-").concat(prop, "-").concat(value));
                }
            }
        }
    };
    createClassName('', {
        size: size,
        offset: offset,
        align: align,
        order: order
    });
    createClassName('-xs', xs);
    createClassName('-sm', sm);
    createClassName('-md', md);
    createClassName('-lg', lg);
    createClassName('-xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: functions.classnames.apply(void 0, _toConsumableArray(classNames).concat([
            className
        ])),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var column_Column = (Column);

;// CONCATENATED MODULE: ./components/base/gridview/column/index.tsx



/***/ }),

/***/ 7923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sg": function() { return /* reexport */ column/* default */.Z; },
  "W2": function() { return /* reexport */ container_Container; },
  "X2": function() { return /* reexport */ row_Row; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/gridview/container/Container.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Container = function(_param) {
    var children = _param.children, className = _param.className, _size = _param.size, size = _size === void 0 ? 'wide' : _size, rest = _objectWithoutProperties(_param, [
        "children",
        "className",
        "size"
    ]);
    var classNames = (0,functions.classnames)('container', "container-".concat(size), className);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: classNames
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var container_Container = (Container);

;// CONCATENATED MODULE: ./components/base/gridview/container/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/row/Row.tsx


function Row_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Row_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Row_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Row_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Row_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Row_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Row = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, content = _param.content, direction = _param.direction, gutter = _param.gutter, justify = _param.justify, wrap = _param.wrap, children = _param.children, testId = _param.testId, rest = Row_objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "content",
        "direction",
        "gutter",
        "justify",
        "wrap",
        "children",
        "testId"
    ]);
    var classNames = {
        'row-align': align,
        'row-content': content,
        'row-direction': direction,
        'row-gutter': gutter,
        'row-justify': justify,
        'row-wrap': wrap
    };
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value) {
                classNames["row-".concat(breakpoint, "-").concat(prop)] = value;
            }
        }
    };
    createClassName('xs', xs);
    createClassName('sm', sm);
    createClassName('md', md);
    createClassName('lg', lg);
    createClassName('xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", Row_objectSpread({
        className: (0,functions.classnames)('row', classNames, className),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var row_Row = (Row);

;// CONCATENATED MODULE: ./components/base/gridview/row/index.tsx


// EXTERNAL MODULE: ./components/base/gridview/column/index.tsx + 1 modules
var column = __webpack_require__(3302);
;// CONCATENATED MODULE: ./components/base/gridview/index.tsx





/***/ }),

/***/ 9617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iz": function() { return /* reexport */ AppContextProvider; },
  "qD": function() { return /* reexport */ useApp; }
});

// UNUSED EXPORTS: AppContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./core/contexts/app/context.tsx

var AppContext = /*#__PURE__*/ (0,react.createContext)(null);
var AppContextProvider = AppContext.Provider;
var useApp = function() {
    var app = (0,react.useContext)(AppContext);
    if (app) {
        return app;
    }
    throw new Error('useApp must be used within a AppContextProvider.');
};

;// CONCATENATED MODULE: ./core/contexts/app/index.tsx



/***/ }),

/***/ 58:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ path_namespaceObject; }
});

// UNUSED EXPORTS: color

// NAMESPACE OBJECT: ./core/utils/path.ts
var path_namespaceObject = {};
__webpack_require__.r(path_namespaceObject);
__webpack_require__.d(path_namespaceObject, {
  "app": function() { return app; },
  "asset": function() { return asset; },
  "url": function() { return url; }
});

;// CONCATENATED MODULE: ./constants/enums.ts
var NodeEnv;
(function(NodeEnv) {
    NodeEnv["Development"] = "development";
    NodeEnv["Production"] = "production";
    NodeEnv["Test"] = "test";
})(NodeEnv || (NodeEnv = {}));

;// CONCATENATED MODULE: ./core/utils/path.ts

/**
 * The ``app`` function returns the fully qualified path to the app directory.
 * You may also use the ``app`` function to generate a fully qualified path
 * to a given file relative to the application directory.
 *
 * @param {string} pathname Added directory path
 * @returns {string}
 */ var app = function(context, pathname) {
    var origin = context.url || '/';
    if (!pathname || typeof pathname !== 'string') return origin;
    if (pathname.indexOf('http') === 0) {
        return pathname;
    }
    if (context.environment === NodeEnv.Production) {
        return "/".concat(pathname);
    }
    return "/".concat(context.key, "/").concat(pathname);
};
var url = function(context, pathname) {
    var origin = context.url || '/';
    if (context.environment === NodeEnv.Production) {
        return "".concat(origin, "/").concat(pathname);
    }
    return "".concat(origin, "/").concat(context.key, "/").concat(pathname);
};
var asset = function(context, path) {
    if (!path) return '';
    if (path.indexOf('http') !== -1) {
        return path;
    } else {
        return "".concat(context.cdn, "/").concat(path);
    }
};

;// CONCATENATED MODULE: ./core/utils/index.ts






/***/ }),

/***/ 6034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pathname_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var app = __webpack_require__(9617);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
;// CONCATENATED MODULE: ./components/index.tsx


var Accordion = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(814)]).then(__webpack_require__.bind(__webpack_require__, 814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(814)
            ];
        }
    }
});
var Answers = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(3)]).then(__webpack_require__.bind(__webpack_require__, 5003));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5003)
            ];
        }
    }
});
var Button = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(664)]).then(__webpack_require__.bind(__webpack_require__, 5664));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5664)
            ];
        }
    }
});
var ChargeLocation = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(662), __webpack_require__.e(255), __webpack_require__.e(351), __webpack_require__.e(129)]).then(__webpack_require__.bind(__webpack_require__, 2129));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2129)
            ];
        }
    }
});
var ChargeStation = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(133)]).then(__webpack_require__.bind(__webpack_require__, 5133));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5133)
            ];
        }
    }
});
var ChargeUnits = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(186)]).then(__webpack_require__.bind(__webpack_require__, 5186));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5186)
            ];
        }
    }
});
var Footer = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(110)]).then(__webpack_require__.bind(__webpack_require__, 8110));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8110)
            ];
        }
    }
});
var GGMRecipe = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(574)]).then(__webpack_require__.bind(__webpack_require__, 2574));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2574)
            ];
        }
    }
});
var Header = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(15)]).then(__webpack_require__.bind(__webpack_require__, 3015));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3015)
            ];
        }
    }
});
var Heading = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 884).then(__webpack_require__.bind(__webpack_require__, 1884));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1884)
            ];
        }
    }
});
var Html = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 791).then(__webpack_require__.bind(__webpack_require__, 9791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9791)
            ];
        }
    }
});
var Image = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 351).then(__webpack_require__.bind(__webpack_require__, 6475));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6475)
            ];
        }
    }
});
var LocationAnswers = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(122)]).then(__webpack_require__.bind(__webpack_require__, 7122));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7122)
            ];
        }
    }
});
var MobileApp = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(987)]).then(__webpack_require__.bind(__webpack_require__, 4987));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4987)
            ];
        }
    }
});
var News = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(574)]).then(__webpack_require__.bind(__webpack_require__, 2574));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2574)
            ];
        }
    }
});
var NewsList = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(125)]).then(__webpack_require__.bind(__webpack_require__, 7125));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7125)
            ];
        }
    }
});
var Partners = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(172)]).then(__webpack_require__.bind(__webpack_require__, 172));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(172)
            ];
        }
    }
});
var Price = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(406)]).then(__webpack_require__.bind(__webpack_require__, 4406));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4406)
            ];
        }
    }
});
var Section = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(263)]).then(__webpack_require__.bind(__webpack_require__, 2263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2263)
            ];
        }
    }
});
var Slider = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(148)]).then(__webpack_require__.bind(__webpack_require__, 8148));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8148)
            ];
        }
    }
});
var Vheicles = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(882)]).then(__webpack_require__.bind(__webpack_require__, 1882));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1882)
            ];
        }
    }
});
var OperationRepair = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(342)]).then(__webpack_require__.bind(__webpack_require__, 4342));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4342)
            ];
        }
    }
});
var Video = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 254).then(__webpack_require__.bind(__webpack_require__, 4254));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4254)
            ];
        }
    }
});
var SoftwareInformation = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 886).then(__webpack_require__.bind(__webpack_require__, 5886));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5886)
            ];
        }
    }
});
var PriceMethod = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(404)]).then(__webpack_require__.bind(__webpack_require__, 3404));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3404)
            ];
        }
    }
});
var ServicesRepair = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(998)]).then(__webpack_require__.bind(__webpack_require__, 4998));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4998)
            ];
        }
    }
});
var Banner = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(354)]).then(__webpack_require__.bind(__webpack_require__, 9354));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9354)
            ];
        }
    }
});
var Contact = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(557)]).then(__webpack_require__.bind(__webpack_require__, 5557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5557)
            ];
        }
    }
});
var QuestionAnswer = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(644)]).then(__webpack_require__.bind(__webpack_require__, 6644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6644)
            ];
        }
    }
});
var Offer = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(702)]).then(__webpack_require__.bind(__webpack_require__, 702));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(702)
            ];
        }
    }
});
var Products = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(745)]).then(__webpack_require__.bind(__webpack_require__, 946));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(946)
            ];
        }
    }
});
var NewsContent = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 627).then(__webpack_require__.bind(__webpack_require__, 5627));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5627)
            ];
        }
    }
});
function getter(name) {
    switch(name){
        case 'heading':
            return Heading;
        case 'html':
            return Html;
        case 'container':
            return gridview/* Container */.W2;
        case 'row':
            return gridview/* Row */.X2;
        case 'column':
            return gridview/* Column */.sg;
        case 'button':
            return Button;
        case 'accordion':
            return Accordion;
        case 'image':
            return Image;
        case 'section':
            return Section;
        case 'video':
            return Video;
        case 'header':
            return Header;
        case 'slider':
            return Slider;
        case 'footer':
            return Footer;
        case 'mobile-app':
            return MobileApp;
        case 'charge-location':
            return ChargeLocation;
        case 'charge-station':
            return ChargeStation;
        case 'charge-units':
            return ChargeUnits;
        case 'news':
            return News;
        case 'news-list':
            return NewsList;
        case 'partners':
            return Partners;
        case 'answers':
            return Answers;
        case 'ggm-recipe':
            return GGMRecipe;
        case 'price':
            return Price;
        case 'vheicles':
            return Vheicles;
        case 'banner':
            return Banner;
        case 'location-answers':
            return LocationAnswers;
        case 'software-information':
            return SoftwareInformation;
        case 'price-method':
            return PriceMethod;
        case 'operation-repair':
            return OperationRepair;
        case 'services-repair':
            return ServicesRepair;
        case 'contact':
            return Contact;
        case 'question-answer':
            return QuestionAnswer;
        case 'offer':
            return Offer;
        case 'evc-products':
            return Products;
        case 'bizden-haberler-content':
            return NewsContent;
    }
};

;// CONCATENATED MODULE: ./core/render.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var render = function(component1, context) {
    var id = component1.id, name = component1.name, props = component1.props, refs = component1.refs, children = component1.children;
    if (name === 'view') {
        var view = context.page.views[id];
        if (view) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: view.map(function(component) {
                    return render(component, context);
                })
            }, id));
        }
    } else {
        var Component = getter(name);
        if (Component) {
            if (children.length) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs, {
                    children: children.map(function(child) {
                        return render(child, context);
                    })
                }), id));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs), id));
            }
        }
        if (false) {}
    }
};
/* harmony default export */ var core_render = (render);

;// CONCATENATED MODULE: ./components/error/Error.tsx

var Error = function(param) {
    var code = param.code, type = param.type, message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "error",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "error-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: code
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/wap-platform.svg",
                alt: "WAP Platform"
            })
        ]
    }));
};
/* harmony default export */ var error_Error = (Error);

;// CONCATENATED MODULE: ./components/error/index.tsx


// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/base/seo-meta/SeoMeta.tsx




var SeoMeta = function(param) {
    var _context = param.context, page = _context.page, settings = _context.settings, environment = _context.environment;
    var suffix = "- ".concat(settings.shortName);
    var title = page.metatags.title || "".concat(page.title, " ").concat(suffix);
    var description = page.metatags.description || title;
    var url = utils/* path.url */.E.url(environment, page.path);
    var renderTitle = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("title", {
            children: title
        });
    };
    var renderMetaDescription = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "description",
            content: description
        }));
    };
    var renderMetaOg = function() {
        var ref, ref1;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:title",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:description",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:site_name",
                    content: settings.title || settings.shortName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref1 = page.image) === null || ref1 === void 0 ? void 0 : ref1.src))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:url",
                    content: url
                })
            ]
        }));
    };
    var renderMetaGoogle = function() {
        var ref, ref2;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "name",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref2 = page.image) === null || ref2 === void 0 ? void 0 : ref2.src))
                })
            ]
        }));
    };
    var renderMetaTwitter = function() {
        var ref, ref3, ref4;
        var twitter = page.metatags.twitter;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:title",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:site",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.site) || url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:description",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.summary) || (twitter === null || twitter === void 0 ? void 0 : twitter.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:image:src",
                    content: utils/* path.asset */.E.asset(environment, (twitter === null || twitter === void 0 ? void 0 : (ref = twitter.summaryImage) === null || ref === void 0 ? void 0 : ref.src) || (twitter === null || twitter === void 0 ? void 0 : (ref3 = twitter.image) === null || ref3 === void 0 ? void 0 : ref3.src) || ((ref4 = page.image) === null || ref4 === void 0 ? void 0 : ref4.src))
                })
            ]
        }));
    };
    var renderMetaOptions = function() {
        var content = [];
        if (page.metatags.isNoIndex) {
            content.push('noindex');
        }
        if (page.metatags.isNoFollow) {
            content.push('nofollow');
        }
        if (!content.length) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: content.join(',')
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            renderTitle(),
            renderMetaDescription(),
            renderMetaOg(),
            renderMetaGoogle(),
            renderMetaTwitter(),
            renderMetaOptions()
        ]
    }));
};
/* harmony default export */ var seo_meta_SeoMeta = (SeoMeta);

;// CONCATENATED MODULE: ./components/base/seo-meta/index.ts


// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
;// CONCATENATED MODULE: ./pages/[...pathname].tsx









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _pathname_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _pathname_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _pathname_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Page = function(_param1) {
    var error = _param1.error, context = _objectWithoutProperties(_param1, [
        "error"
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        if (context.language) {
            var cookie = new es6/* default */.Z();
            cookie.set('language', context.language);
        }
    }, [
        context
    ]);
    var renderColorPalette = function() {
        var _theme = context.theme, colors = _theme.colors, neutrals = _theme.neutrals;
        var getcss = function(name, tones) {
            var entries = Object.entries(tones);
            return entries.map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                if (name.length == 2) {
                    return "--".concat(name).concat(key, ": ").concat(value, ";\n                    --").concat(name).concat(key, "-RGB: ").concat(value.replace(/[rgb|\(\)]/gm, ''), ";");
                }
                return "--".concat(name).concat(key, ": ").concat(value, ";");
            }).join('');
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
            type: "text/css",
            children: ":root {".concat([
                getcss('DN', neutrals.dark),
                getcss('LN', neutrals.light),
                getcss('PC', colors.primary),
                getcss('R', colors.red),
                getcss('Y', colors.yellow),
                getcss('G', colors.green),
                getcss('B', colors.blue),
                getcss('P', colors.purple),
                getcss('T', colors.teal), 
            ].join(''), "}")
        }));
    };
    var renderStyle = function() {
        var styles = context.settings.styles;
        if (styles) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                type: "text/css",
                children: styles
            }));
        }
    };
    var renderAlternates = function() {
        var alternates = context.page.alternates;
        if (alternates) {
            return alternates.map(function(param, index) {
                var title = param.title, href = param.href, hreflang = param.hreflang;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    title: title,
                    hrefLang: hreflang,
                    href: href
                }, index);
            });
        }
    };
    var renderPlugins = function() {
        var plugins = context.settings.plugins;
        return plugins.map(function(item) {
            return (0,html_react_parser/* default */.ZP)(item);
        });
    };
    if (error) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(error_Error, _pathname_objectSpread({}, error)));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.StrictMode, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: context.page.title
                    }),
                    renderAlternates(),
                    renderColorPalette(),
                    renderPlugins(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/...BHWRJSY4ZW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        children: "\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n          gtag('config', 'G-BHWRJSY4ZW');\n        "
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_meta_SeoMeta, {
                context: context
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(app/* AppContextProvider */.iz, {
                value: context,
                children: context.page.layout.map(function(component) {
                    return core_render(component, context);
                })
            }),
            renderStyle()
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _pathname_ = (Page);


/***/ })

}]);